import { WorkspaceSizeThresholds } from "@/common/constants";
import { interactionBarShadow } from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		flex: 1,
		maxWidth: "50%",
	},
	workspaceContainer: {
		flex: 1,
		maxWidth: "50%",
		height: "100%",
		width: "100%",
		position: "relative",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		overflow: "unset"
	},
	workspaceContainerLight: {
		backgroundColor: tokens.colorNeutralBackground1,
	},
	interactionBarContainer: {
		position: "relative",
		height: "100%",
		width: "100%",
		minHeight: "0px",
	},
	interactionBar: {
		height: "60px",
		paddingRight: "5px",
	},

	interactionDescription: {
		marginRight: "0px",
	},

	handlingStatus: {
		width: "60px",
	},
	minWidthZero: {
		minWidth: 0,
	},
	conversation: {
		display: "flex",
		flexDirection: "column",
		height: "calc(100vh - 125px)",

		[`@container workspacePanel (width >= ${WorkspaceSizeThresholds.Small}px) and (width < 757px )`]:
		{
			height: "calc(100vh - 185px)",
		},

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Small}px)`]:
		{
			height: "calc(100vh - 245px)",
		},
	},
	unavailableConversationPlaceholderRoot: {
		width: "100%",
		height: "100%",
		padding: "13px 16px 0px 16px",
	},
	unavailableConversationPlaceholder: {
		width: "100%",
		height: "100%",
		backgroundColor: tokens.colorNeutralBackground1,
		borderTopLeftRadius: "4px",
		borderTopRighttRadius: "4px",
		...interactionBarShadow(),
	},
	audioPlayer: {
		margin: "30px 0px 0px 0px",
		minHeight: "60px",
		flexShrink: 0,
		overflow: "hidden",
	},
	recordingsScroll: {
		minWidth: 0,
		maxWidth: "100%",
		height: "78px",
		overflowX: "auto",
		overflowY: "hidden",
	},
	parent: {
		height: "100%",
		boxShadow: tokens.shadow4,
		backgroundColor: tokens.colorNeutralBackground1,
		margin: "13px 16px 16px 16px",
	},
	middle: {
		height: "60px",
		maxHeight: "60px",
	},
	bottom: {
		flex: "1 1 auto",
		minHeight: 0, // allows scroll to work inside flex container
		overflow: "auto",
		padding: "0px 16px 16px 16px",
		boxSizing: "border-box",
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
});
